import {
    MarketResearchSupplyDemandData,
    MarketResearchSupplyDemandMonthlyTrend,
    MarketResearchSupplyDemandSummaryData,
    MarketResearchSupplyDemandTopEmployer,
    SummaryRating,
} from "../../features";
import {
    MarketResearchSupplyDemandEmployerResponse,
    MarketResearchSupplyDemandResponse,
    MarketResearchSupplyDemandSummaryResponse,
} from ".";

export const convertMarketResearchSupplyDemandResponse = (
    res: MarketResearchSupplyDemandResponse
) => {
    if (!res) return null;

    const result: MarketResearchSupplyDemandData = {
        summary: convertMarketResearchSupplyDemandSummaryResponse(
            res.supplyDemandSummary
        ),
        topEmployers: res.topEmployers.map(x =>
            convertMarketResearchSupplyDemandEmployerResponse(x)
        ),
        demandTrends: res.demandTrends.map(x =>
            convertMarketResearchSupplyDemandMonthlyTrend(x)
        ),
    };

    return result;
};

export const convertMarketResearchSupplyDemandSummaryResponse = (
    res: MarketResearchSupplyDemandSummaryResponse
) => {
    if (!res) return null;

    const result: MarketResearchSupplyDemandSummaryData = {
        supplyCount: res.supplyCount,
        demandCount: res.demandCount,
        rating: SummaryRating.fromId(res.ratingTypeId),
    };

    return result;
};

const convertMarketResearchSupplyDemandEmployerResponse = (
    res: MarketResearchSupplyDemandEmployerResponse
) => {
    if (!res) return null;

    const result: MarketResearchSupplyDemandTopEmployer = {
        name: res.name,
        demandCount: res.demandCount,
    };
    return result;
};

const convertMarketResearchSupplyDemandMonthlyTrend = (
    res: MarketResearchSupplyDemandMonthlyTrend
) => {
    if (!res) return null;

    const result: MarketResearchSupplyDemandMonthlyTrend = {
        periodName: res.periodName,
        periodNumber: res.periodNumber,
        demandCount: res.demandCount,
    };
    return result;
};
